
import React from 'react';
import { APP_INFO } from '../constants';
import { Info as InfoIcon, ShieldCheck, Zap, Leaf, Map, Database } from 'lucide-react';

export const Info: React.FC = () => {
  return (
    <div className="space-y-6 animate-fade-in pb-12">
      <div className="text-center py-6 border-b border-raizama-border/10">
        <div className="w-32 h-32 mx-auto mb-4 flex items-center justify-center">
            <img 
              src={APP_INFO?.LOGO_URL || ''} 
              alt="Logo Raizama Garden" 
              className="w-full h-full object-contain drop-shadow-2xl" 
            />
        </div>
        <h2 className="text-2xl font-black text-raizama-textMain tracking-tight uppercase">{APP_INFO.NAME}</h2>
        <p className="text-sm italic text-raizama-textSec mt-2 font-bold px-8">"{APP_INFO.SLOGAN}"</p>
      </div>

      <div className="space-y-6 text-sm text-raizama-textSec px-2">
        <section className="bg-raizama-surface/50 p-5 rounded-2xl border border-raizama-border/10">
            <h3 className="text-raizama-highlight font-black text-xs uppercase tracking-widest mb-3 flex items-center gap-2">
                <InfoIcon size={16} /> Sobre o Aplicativo
            </h3>
            <p className="leading-relaxed">O Raizama Garden CARE foi projetado como uma ferramenta definitiva para colecionadores e entusiastas da botânica. Nosso objetivo é transformar o cuidado complexo em uma rotina organizada e prazerosa.</p>
        </section>

        <section className="space-y-3">
            <h3 className="text-raizama-highlight font-black text-xs uppercase tracking-widest mb-4 flex items-center gap-2">
                <Zap size={16} /> Funcionalidades e Dados
            </h3>
            
            <div className="grid gap-3">
                <div className="flex gap-4 p-4 bg-raizama-surface/30 rounded-xl border border-raizama-border/5">
                    <Database className="text-raizama-action shrink-0" size={20} />
                    <div>
                        <strong className="text-white block text-xs uppercase mb-1">Catálogo Digital</strong>
                        <p className="text-[11px] leading-relaxed">Armazenamento seguro de fotos, nomes científicos e classificações de toda a sua coleção.</p>
                    </div>
                </div>

                <div className="flex gap-4 p-4 bg-raizama-surface/30 rounded-xl border border-raizama-border/5">
                    <Leaf className="text-raizama-action shrink-0" size={20} />
                    <div>
                        <strong className="text-white block text-xs uppercase mb-1">Manejo Inteligente</strong>
                        <p className="text-[11px] leading-relaxed">Controle detalhado de rega, adubação e podas, com assistência de IA para sugestões botânicas.</p>
                    </div>
                </div>

                <div className="flex gap-4 p-4 bg-raizama-surface/30 rounded-xl border border-raizama-border/5">
                    <Map className="text-raizama-action shrink-0" size={20} />
                    <div>
                        <strong className="text-white block text-xs uppercase mb-1">Geolocalização</strong>
                        <p className="text-[11px] leading-relaxed">Mapeamento preciso de cada espécime, permitindo saber a localização exata no jardim ou origem.</p>
                    </div>
                </div>

                <div className="flex gap-4 p-4 bg-raizama-surface/30 rounded-xl border border-raizama-border/5">
                    <ShieldCheck className="text-raizama-action shrink-0" size={20} />
                    <div>
                        <strong className="text-white block text-xs uppercase mb-1">Segurança de Dados</strong>
                        <p className="text-[11px] leading-relaxed">Seus dados são privados e protegidos. Apenas você tem acesso à sua coleção e imagens.</p>
                    </div>
                </div>
            </div>
        </section>

        <div className="bg-raizama-surface/80 p-5 rounded-2xl border border-raizama-border/20 mt-8 flex justify-between items-center shadow-lg">
            <div>
                <h3 className="text-white font-black text-xs uppercase tracking-wider">Versão Estável</h3>
                <p className="text-[10px] text-raizama-textSec font-bold">Versão: {APP_INFO.VERSION} - Official</p>
            </div>
            <div className="px-3 py-1 bg-raizama-action/20 rounded-full border border-raizama-action/30">
                <span className="text-[10px] text-raizama-action font-black uppercase">PRO</span>
            </div>
        </div>

        <div className="text-center mt-12 pt-8 border-t border-raizama-border/10 opacity-60">
            <p className="text-[10px] font-black text-raizama-textSec uppercase tracking-[0.4em]">
              Desenvolvido por Raizama Garden 2026
            </p>
        </div>
      </div>
    </div>
  );
};
